// extracted by mini-css-extract-plugin
export default {"container":"Login_container__lCF9u","title":"Login_title__3JYIy","subTitle":"Login_subTitle__rUx69","inputBox":"Login_inputBox__HTfX4","loginBox":"Login_loginBox__es-oX"};